<script setup lang="ts">
import {onBeforeMount, PropType, Ref, ref} from "vue";

const props = defineProps({
	modelValue: {
		type: Object as PropType<App.Data.Explorer.Filter.FilterValueDTO[]>,
		require: true,
	}
});

const emit = defineEmits(["update:modelValue"]);

onBeforeMount(() => {
	localModelValue.value = props.modelValue || [];
})

const emitChange = () => {
	emit("update:modelValue", localModelValue.value);
}

const localModelValue: Ref<App.Data.Explorer.Filter.FilterValueDTO[]> = ref(null);

// DO NOT touch the id's they are used as input for the query
const HoursOfDay = [
	{id: 0, level: null, selection_depth: null, model: null, label: '00:00 - 01:00'},
	{id: 1, level: null, selection_depth: null, model: null, label: '01:00 - 02:00'},
	{id: 2, level: null, selection_depth: null, model: null, label: '02:00 - 03:00'},
	{id: 3, level: null, selection_depth: null, model: null, label: '03:00 - 04:00'},
	{id: 4, level: null, selection_depth: null, model: null, label: '04:00 - 05:00'},
	{id: 5, level: null, selection_depth: null, model: null, label: '05:00 - 06:00'},
	{id: 6, level: null, selection_depth: null, model: null, label: '06:00 - 07:00'},
	{id: 7, level: null, selection_depth: null, model: null, label: '07:00 - 08:00'},
	{id: 8, level: null, selection_depth: null, model: null, label: '08:00 - 09:00'},
	{id: 9, level: null, selection_depth: null, model: null, label: '09:00 - 10:00'},
	{id: 10, level: null, selection_depth: null, model: null, label: '10:00 - 11:00'},
	{id: 11, level: null, selection_depth: null, model: null, label: '11:00 - 12:00'},
	{id: 12, level: null, selection_depth: null, model: null, label: '12:00 - 13:00'},
	{id: 13, level: null, selection_depth: null, model: null, label: '13:00 - 14:00'},
	{id: 14, level: null, selection_depth: null, model: null, label: '14:00 - 15:00'},
	{id: 15, level: null, selection_depth: null, model: null, label: '15:00 - 16:00'},
	{id: 16, level: null, selection_depth: null, model: null, label: '16:00 - 17:00'},
	{id: 17, level: null, selection_depth: null, model: null, label: '17:00 - 18:00'},
	{id: 18, level: null, selection_depth: null, model: null, label: '18:00 - 19:00'},
	{id: 19, level: null, selection_depth: null, model: null, label: '19:00 - 20:00'},
	{id: 20, level: null, selection_depth: null, model: null, label: '20:00 - 21:00'},
	{id: 21, level: null, selection_depth: null, model: null, label: '21:00 - 22:00'},
	{id: 22, level: null, selection_depth: null, model: null, label: '22:00 - 23:00'},
	{id: 23, level: null, selection_depth: null, model: null, label: '23:00 - 24:00'},
];
</script>

<template>
	<v-autocomplete
		placeholder="Select a Value"
		:items="HoursOfDay"
		item-title="label"
		item-value="id"
		multiple
		return-object
		:clearable="true"
		v-model="localModelValue"
		@update:modelValue="emitChange()"
	/>
</template>

<style lang="scss" scoped></style>
